export interface NavbarItem {
  svg: string;
  key: NavbarItemEnum;
  path: string;
  action?: NavBarAction;
  isActivated: boolean;
  isOnNavBar: boolean;
  matchExactPath: boolean;
  notif: NavbarItemNotif | null;
}

export type NavBarAction = 'OPEN_SURVEY';

export interface NavbarItemNotif {
  count: number | null;
}

export enum NavbarItemEnum {
  Home = 'Home',
  Reload = 'Reload',
  Order = 'Order',
  Book = 'Book',
  History = 'History',
  Account = 'Account',
  Survey = 'Survey',
}
